const aws_region = "us-east-1";

const config = {
  appName: "Cash Sweep UI - Non Prod",
  region: aws_region,
  cognito: {
    userPoolId: `${aws_region}_lAEfn09Ej`,
    domain: `pgi-cashsweep-domain-nonprd.auth.${aws_region}.amazoncognito.com`,
    tokenUrl: `https://pgi-cashsweep-domain-nonprd.auth.${aws_region}.amazoncognito.com/oauth2/authorize`,
    providerId: "pgi-cashsweep-identity-provider",
    redirectUrl: "https://www.gmmcashsweep.fundaccounting.staging.principal.com",
    clientId: "4hu3a5jskg9isa3vqfeh6l2hoe",
    scope: "pgi-cashsweep-resource-server/read-write",
    updateGroup: "pgi-cashsweep-read-write-client",
  },
  api: {
    baseUrl: `https://jkxehphdwe.execute-api.us-east-1.amazonaws.com/prod/api/v1`,
  },
};

export default config;
